import React from 'react';
import { connect } from 'react-redux';

const OrderRowQty = props => {
  const { order } = props;
  let reqKeys = Object.keys(order.requested);
  return (
    <div>
      <div>
        {`${order.requested[reqKeys[0]]}`}
      </div>
      <div>шт</div>
    </div>
  );
}

export default connect()(OrderRowQty);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-confirmed/qty.js